<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-button
        type="primary"
        v-role="['1']"
        class="add"
        size="small"
        @click="addAccount"
      >
        <i class="el-icon-plus"></i>
        添加管理用户
      </el-button>
      <el-button
        type="primary"
        v-role="['1']"
        class="add"
        size="small"
        @click="addTeam"
      >
        <i class="el-icon-plus"></i>
        添加代表队用户
      </el-button>
      <el-button
        type="primary"
        v-role="['1']"
        class="add"
        size="small"
        @click="addHost"
      >
        <i class="el-icon-plus"></i>
        添加主办方用户
      </el-button>
      <el-button
        type="danger"
        v-role="['1']"
        size="small"
        class="delete"
        @click="delMulData"
      >
        <i class="el-icon-delete"></i>删除
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入账号"
              clearable
              v-model="searchForm.account"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.accountType"
              placeholder="用户类型"
              clearable
            >
              <el-option :value="1" label="系统用户" />
              <el-option :value="3" label="主办方" />
              <el-option :value="2" label="代表队" />
            </el-select>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="searchdata"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
      <el-table-column
        width="80"
        prop="id"
        label="序号"       
        align="center"
      >
    <template slot-scope="scope">
      {{ (searchForm.page - 1) * searchForm.pageSize + scope.$index + 1 }}
    </template>
    </el-table-column>
      <el-table-column
        prop="displayName"
        align="center"
        label="名称"
      ></el-table-column>
      <el-table-column
        prop="loginName"
        align="center"
        label="账户"
      ></el-table-column>
      <el-table-column
        prop="accountType"
        align="center"
        label="类型"
        :formatter="accountTypeFormatter"
      ></el-table-column>
      <el-table-column
        prop="mobile"
        align="center"
        label="手机号"
      ></el-table-column>
      <el-table-column
        prop="status"
        align="center"
        label="状态"
        :formatter="statusFormatter"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        fixed="right"
        width="170"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="deleteAccount(scope.row)"
            class="btn"
            size="small"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="editAccount(scope.row)"
            class="btn"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="resetAccount(scope.row)"
            class="btn"
            >重置密码</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[1, 5, 15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增弹框-->
    <el-dialog
      :title="'管理用户'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="名称" prop="displayName">
          <el-input v-model="form.displayName" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="loginName">
          <el-input v-model="form.loginName" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" maxlength="255"></el-input>
        </el-form-item>
        <!--<el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" maxlength="255"></el-input>
        </el-form-item>-->
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status">
            <el-option
              v-for="item in statusOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="'修改用户'"
      :inline="true"
      :visible.sync="dialogEditFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="名称" prop="displayName">
          <el-input v-model="form.displayName" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" maxlength="255"></el-input>
        </el-form-item>

        <el-form-item label="账号" prop="loginName">
          <el-input v-model="form.loginName" maxlength="255"></el-input>
        </el-form-item>

        <el-form-item label="用户类型" prop="accountType">
          <el-select v-model="form.accountType">
            <el-option
              v-for="item in userTypes"
              :label="item.name"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" maxlength="255"></el-input>
        </el-form-item>-->
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status">
            <el-option
              v-for="item in statusOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="'代表队授权'"
      :inline="true"
      :visible.sync="dialogTeamFormVisible"
    >
      <el-form
        :model="formTeam"
        label-position="right"
        label-width="110px"
        :rules="formTeamRules"
        ref="formTeam"
      >
        <el-form-item label="代表队" prop="teamId">
          <el-select v-model="formTeam.teamId">
            <el-option
              v-for="item in teamOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="姓名" prop="displayName">
          <el-input v-model="formTeam.displayName" maxlength="255"></el-input>
        </el-form-item>-->
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="formTeam.mobile" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="loginName">
          <el-input v-model="formTeam.loginName" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="formTeam.password"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="formTeam.status">
            <el-option
              v-for="item in statusOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTeamFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitTeamForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="'主办方授权'"
      :inline="true"
      :visible.sync="dialogHostFormVisible"
    >
      <el-form
        :model="formHost"
        label-position="right"
        label-width="110px"
        :rules="formHostRules"
        ref="formHost"
      >
        <el-form-item label="主办方" prop="hostId">
          <el-select v-model="formHost.hostId">
            <el-option
              v-for="item in hostOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="姓名" prop="displayName">
          <el-input v-model="formHost.displayName" maxlength="255"></el-input>
        </el-form-item>-->
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="formHost.mobile" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="loginName">
          <el-input v-model="formHost.loginName" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="formHost.password"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="address">
          <el-select v-model="formHost.status">
            <el-option
              v-for="item in statusOptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogHostFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitHostForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="'重置密码'"
      :inline="true"
      :visible.sync="dialogResetPasswordVisible"
    >
      <el-form
        ref="resetForm"
        :model="resetForm"
        :rules="resetFormRules"
        label-width="120px"
      >
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="resetForm.newPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            v-model="resetForm.confirmPassword"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogResetPasswordVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="resetUserPassword"
          :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "../apis/account";
import HostApi from "../apis/host";
import TeamApi from "../apis/team";

export default {
  data() {
    var validateMobile = (rule, value, callback) => {
      const reg = /^[0-9]{11}$/;
      if (value == "" || value == undefined || value == null) {
        callback();
      } else {
        if (!reg.test(value) && value != "") {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      }
    };
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.resetForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      isLoading: false,
      dialogResetPasswordVisible: false,
      dialogFormVisible: false,
      dialogEditFormVisible: false,
      dialogTeamFormVisible: false,
      dialogHostFormVisible: false,
      multipleSelection: [],
      total: 0,
      tableListData: [],
      statusOptions: [
        { name: "正常", value: 1 },
        { name: "停用", value: 2 },
      ],
      userTypes: [
        { name: "系统用户", value: 1 },
        { name: "主办方", value: 3 },
        { name: "代表队", value: 2 },
      ],
      searchForm: {
        account: null,
        page: 1,
        pageSize: 15,
      },
      form: {
        id: 0,
        displayName: "",
        loginName: "",
        mobile: "",
        password: "",
        status: 1,
      },
      teamOptions: [],
      formTeam: {
        teamId: null,
        id: 0,
        displayName: "",
        loginName: "",
        mobile: "",
        password: "",
        status: 1,
      },
      hostOptions: [],
      formHost: {
        hostId: null,
        id: 0,
        displayName: "",
        loginName: "",
        mobile: "",
        password: "",
        status: 1,
      },
      resetForm: {
        newPassword: null,
        confirmPassword: null,
        userId: null,
      },
      resetFormRules: {
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: validateConfirmPwd, trigger: "blur" },
        ],
      },
      formRules: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        loginName: [
          { required: true, message: "请输入主办方", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      formTeamRules: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        teamId: [{ required: true, message: "请选择代表队", trigger: "blur" }],
      },
      formHostRules: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        hostId: [{ required: true, message: "请选择主办方", trigger: "blur" }],
      },
    };
  },
  methods: {
    statusFormatter(row, column) {
      var typeName = "";
      switch (row.status) {
        case 1:
          typeName = "正常";
          break;
        case 2:
          typeName = "停用";
          break;
      }
      return typeName;
    },
    accountTypeFormatter(row, column) {
      var typeName = "";
      switch (row.accountType) {
        case 1:
          typeName = "管理用户";
          break;
        case 2:
          typeName = "代表队";
          break;
        case 3:
          typeName = "主办方";
          break;
      }
      return typeName;
    },
    editAccount(row) {
      this.formTitle = "编辑用户";
      API.get({ id: row.id }).then((result) => {
        this.dialogEditFormVisible = true;
        this.form = Object.assign({}, result.result);
      });
    },
    resetAccount(row) {
      this.resetForm.userId = row.id;
      this.dialogResetPasswordVisible = true;
    },
    resetUserPassword() {
      let that = this;
      this.$refs.resetForm.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.resetForm);
          API.resetPassword(params)
            .then(
              (result) => {
                if (result.code == 0) {
                  that.$message.success({
                    showClose: true,
                    message: "更改成功",
                    duration: 2000,
                  });
                  this.$refs["resetForm"].resetFields();
                  this.dialogResetPasswordVisible = false;
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "更改失败",
                    duration: 2000,
                  });
                }
              },
              function (err) {
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        }
      });
    },
    addAccount() {
      this.dialogFormVisible = true;
      this.form = {
        id: 0,
        displayName: "",
        loginName: "",
        mobile: "",
        password: "",
        status: 1,
      };
    },
    addTeam() {
      this.dialogTeamFormVisible = true;
      this.formTeam = {
        teamId: null,
        id: 0,
        displayName: "",
        loginName: "",
        mobile: "",
        password: "",
        status: 1,
      };
    },
    addHost() {
      this.dialogHostFormVisible = true;
      this.formHost = {
        hostId: null,
        id: 0,
        displayName: "",
        loginName: "",
        mobile: "",
        password: "",
        status: 1,
      };
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search();
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search();
    },
    searchdata() {
      this.searchForm.page = 1;
      this.search();
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params)
        .then((result) => {
          if (result && result.code == 0) {
            this.tableListData = result.result.data;
            this.total = result.result.recordCount;
          } else {
            this.$message.error({
              showClose: true,
              message: result.result.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm() {
      let that = this;
      this.isLoading = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form);
          if (params.id > 0) {
            API.edit(params)
              .then(
                (data) => {
                  if (data.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "更改成功",
                      duration: 2000,
                    });
                    that.dialogEditFormVisible = false;
                    that.$refs["form"].resetFields();
                    that.search();
                  } else {
                    this.$message.error({
                      showClose: true,
                      message: data.message,
                      duration: 2000,
                    });
                  }
                  that.isLoading = false;
                },
                function (err) {
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                  that.isLoading = false;
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
                that.isLoading = false;
              });
          } else {
            API.add(params)
              .then((result) => {
                if (result.code == 0) {
                  this.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 2000,
                  });
                  this.$refs["form"].resetFields();
                  this.dialogFormVisible = false;
                  this.search();
                  this.isLoading = false;
                } else {
                  this.$message.error({
                    showClose: true,
                    message: "新增失败",
                    duration: 2000,
                  });
                  this.isLoading = false;
                }
              })
              .catch((error) => {
                this.$message.error({
                  showClose: true,
                  message: "请求异常",
                  duration: 2000,
                });
                this.isLoading = false;
              });
          }
        } else {
          this.isLoading = false;
        }
      });
    },
    submitTeamForm() {
      let that = this;
      this.isLoading = true;
      this.$refs.formTeam.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.formTeam);
          API.addTeam(params)
            .then((result) => {
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "新增代表队账户成功",
                  duration: 2000,
                });
                this.$refs["formTeam"].resetFields();
                this.dialogTeamFormVisible = false;
                this.search();
                this.isLoading = false;
              } else {
                this.$message.error({
                  showClose: true,
                  message: result.message,
                  duration: 2000,
                });
                this.isLoading = false;
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "请求异常",
                duration: 2000,
              });
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
    },
    submitHostForm() {
      let that = this;
      this.isLoading = true;
      this.$refs.formHost.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.formHost);
          API.addHost(params)
            .then((result) => {
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "新增主办方成功",
                  duration: 2000,
                });
                this.$refs["formHost"].resetFields();
                this.dialogHostFormVisible = false;
                this.search();
                this.isLoading = false;
              } else {
                this.$message.error({
                  showClose: true,
                  message: result.message,
                  duration: 2000,
                });
                this.isLoading = false;
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "请求异常",
                duration: 2000,
              });
              this.isLoading = false;
            });
        } else {
          this.isLoading = false;
        }
      });
    },
    deleteAccount(row) {
      let params = { id: row.id };
      this.$confirm("确认删除记录吗？", "提示", { type: "warning" })
        .then(() => {
          API.delete(params)
            .then((result) => {
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "删除成功",
                  duration: 2000,
                });
                this.search();
              } else {
                this.$message.error({
                  showClose: true,
                  message: result.message,
                  duration: 2000,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "系统错误",
                duration: 2000,
              });
            });
        })
        .catch(() => {});
    },
    /*批量删除*/
    delMulData() {
      let that = this;
      let val = that.multipleSelection;
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id);
      }
      this.$confirm("此操作将永久删除该数据，是否继续？", "提示", {
        confimButtonTexe: "确定",
        cancelButtonTexe: "取消",
        type: "warning",
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() })
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 0) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 2000,
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message,
                    duration: 2000,
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        }
      });
      this.$refs.multipleTable.clearSelection();
    },
  },
  computed: {},
  mounted() {
    this.search();
    TeamApi.select().then((res) => {
      this.teamOptions = res.result;
    });
    HostApi.select().then((res) => {
      this.hostOptions = res.result;
    });
  },
};
</script>


// WEBPACK FOOTER //
// src/views/Account.vue